<div 
    [ngClass]="{'component-holder': type === 'component', 'button-holder': type === 'button'}" 
    #holder
>
    <ng-content></ng-content>
</div>